import { AuthProviderFederated } from './AuthProviderFederated';
import { USE_FEDERATED_AUTH } from 'config';

type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) =>
  USE_FEDERATED_AUTH ? <AuthProviderFederated>{children}</AuthProviderFederated> : children;
